import {Tooltip} from 'bootstrap';
import {post} from '../inc/js/ajax';
import {addFormValidation} from '../inc/js/dom_utils';

// Mise en place d'un code similaire dans dom_utils.Popup
document.querySelectorAll('form.needs-validation').forEach(form => {
    addFormValidation(form);
});

new Tooltip(document.body, {
    selector: '[data-bs-toggle="tooltip"]'
});

// Boutons logout (temporaire ou non, surtout pour admin qui n'en a pas)
document.querySelectorAll('#my-navbar .logout')?.forEach(btn => {
    btn.addEventListener('click', async function(e) {
	await post({a: 'logout', alert_success: 1});
	location.href = '/';
    });
});

// Liens vers l'affichage du dernier email envoyé
// Ici pour gestion du cache (sinon pourrait afficher un ancien)
document.querySelectorAll('.show-last-email')?.forEach(btn => {
    btn.addEventListener('click', function(e) {
	e.preventDefault();	    // Si dans un form par accident
	window.open('/tmp/email.html?' + Date.now(), '_blank');
    });
});

